import { getStorageItem, setStorageItem, removeStorageItem } from '@/utils'
import { Message } from 'element-ui';
import Router from '@/router/index'
import store from '../store'
var lastTime = new Date().getTime();
var currentTime = new Date().getTime();
var timeOut = 5 * 60 * 1000; //设置超时时间： 30分

window.onload = function () {
  // window.document.onmousedown = function () {
  //   setStorageItem("lastTime", new Date().getTime());
  // }
};
function checkTimeout() {
  currentTime = new Date().getTime(); //更新当前时间
  lastTime = localStorage.getItem("lastTime");
  // console.log(currentTime - lastTime);
  // console.log(timeOut);
  if (currentTime - lastTime > timeOut) { //判断是否超时
    console.log("超时");
    let token = getStorageItem('authToken')
    if (token) {
      removeStorageItem('authToken')
      Message.error('登录过期,请重新登录')
      Router.push({ path: '/' })
      store.dispatch('getUserInfo', null)
    }
    // var url = window.location.href;
    // var newUrl = url.match(/(\S*)#/)[1];

    // window.open(newUrl + '#/login', '_self');
  }
}

/* 定时器 间隔30秒检测是否长时间未操作页面 */
// window.setInterval(checkTimeout, 30000);



// WEBPACK FOOTER //
// ./src/utils/countTime.js